import styled from "styled-components";

export const LoginFormFormStack = styled.form.attrs({ className: "space-y-6" })``;

export const LoginFormContentStack = styled.div.attrs({ className: "space-y-3" })``;

export const LoginFormInfoRow = styled.div.attrs({
  className:
    "inline-flex items-center gap-2 rounded-full border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-2 text-xs uppercase tracking-[0.28em] text-[var(--brand-highlight)]",
})``;

export const LoginFormSectionHeading = styled.h2.attrs({
  className: "text-3xl text-[var(--brand-ink)]",
})``;

export const LoginFormBodyText = styled.p.attrs({
  className: "mt-3 max-w-md text-sm leading-7 text-[var(--brand-muted)]",
})``;

export const LoginFormContentStackSecondary = styled.div.attrs({ className: "space-y-4" })``;

export const LoginFormContentStackTertiary = styled.div.attrs({ className: "space-y-2" })``;

export const LoginFormFieldLabel = styled.label.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const LoginFormPanelCard = styled.div.attrs({
  className:
    "rounded-3xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] p-4 shadow-[0_18px_34px_rgba(0,0,0,0.22)]",
})``;

export const LoginFormSection = styled.div.attrs({ className: "flex items-start gap-3" })``;

export const LoginFormInlineText = styled.span.attrs({
  className:
    "mt-1 inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-[rgba(255,255,255,0.05)] text-[var(--brand-highlight)]",
})``;

export const LoginFormContentStackQuaternary = styled.div.attrs({
  className: "min-w-0 flex-1 space-y-3",
})``;

export const LoginFormLabelText = styled.p.attrs({
  className: "text-sm font-medium text-[var(--brand-ink)]",
})``;

export const LoginFormBodyTextSecondary = styled.p.attrs({
  className: "mt-1 text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const LoginFormInlineTextSecondary = styled.span.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const LoginFormFieldSelect = styled.select.attrs({ className: "brand-input" })``;

export const LoginFormEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-highlight)]",
})``;

export const LoginFormFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const LoginFormTextBlock = styled.p.attrs({
  className: "text-sm text-[var(--brand-error-text)]",
})``;

export const LoginFormFieldShell = styled.div.attrs({ className: "relative" })``;

export const LoginFormFieldInputSecondary = styled.input.attrs({
  className: "brand-input pr-12",
})``;

export const LoginFormActionButton = styled.button.attrs({
  className: "absolute right-4 top-1/2 -translate-y-1/2 text-[var(--brand-muted)]",
})``;

export const LoginFormHeaderRow = styled.div.attrs({
  className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
})``;

export const LoginFormMetaText = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const LoginFormPrimaryButton = styled.button.attrs({
  className:
    "brand-button inline-flex items-center justify-center gap-2 px-5 py-3 text-sm disabled:cursor-not-allowed disabled:opacity-60",
})``;
